module.exports = __webpack_public_path__ + "ec998f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/BasicHeader/SYR_OCEANIC_Logo.png
// module id = 1114
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20